import { observer } from 'mobx-react-lite';
import { Form, Formik } from 'formik';
import Popup from '../../../../components/common-components/pop-up/Popup';
import { Clock } from 'lucide-react';
import { useStore } from '../../../../hooks/useStore';
import FormPopupFooter from '../../../../components/form-components/common-components/FormPopupFooter';
import { OvertimeFormSchema } from '../../../../schemas/OvertimeFormSchema';
import {
  getDefaultOvertimeFormValues,
  parseFormDates,
  type OvertimeFormValues,
} from './overtimeFormUtils';
import OvertimeFormFields from './OvertimeFormFields';
import styles from './NewOvertimePopup.module.css';

const NewOvertimePopup = () => {
  const { popupStore, overtimeStore, authStore } = useStore();

  const handleClose = () => {
    popupStore.setIsNewOvertimeOpen(false);
  };

  const handleSubmit = async (values: OvertimeFormValues) => {
    const { startDate, endDate, totalHours } = parseFormDates(values);

    const response = await overtimeStore.createOvertime({
      startDate,
      endDate,
      description: values.description,
      status: 'Pending',
      overtimeType: 'Overtime',
      userId: authStore.user?.id?.toString(),
      totalHours,
    });

    if (!response?.error) {
      popupStore.setIsNewOvertimeOpen(false);
    }
  };

  if (!popupStore.isNewOvertimeOpen) {
    return null;
  }

  return (
    <Formik
      initialValues={getDefaultOvertimeFormValues()}
      validationSchema={OvertimeFormSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Popup
          isOpen={popupStore.isNewOvertimeOpen}
          onClose={handleClose}
          title="Yeni Mesai Kaydı"
          description="Yeni mesai kaydı oluşturun"
          variant="success"
          icon={<Clock size={22} strokeWidth={2} />}
          footer={() => <FormPopupFooter onClose={handleClose} />}
        >
          <Form className={styles.form}>
            <OvertimeFormFields descriptionPlaceholder="Mesai açıklamasını giriniz..." />
          </Form>
        </Popup>
      )}
    </Formik>
  );
};

export default observer(NewOvertimePopup);
